import { render, staticRenderFns } from "./StFiltersPagination.vue?vue&type=template&id=6fe732a0&scoped=true"
import script from "./StFiltersPagination.vue?vue&type=script&lang=js"
export * from "./StFiltersPagination.vue?vue&type=script&lang=js"
import style0 from "./StFiltersPagination.vue?vue&type=style&index=0&id=6fe732a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe732a0",
  null
  
)

export default component.exports